import { useState, useEffect, useMemo } from 'react';
import { findRate, getCurrencies, getDMCategories, getDMItems, getDMSubAndMainCategories, getDMThemes, toastMessage } from '../utils/helper';
import { ToastContainer } from 'react-toastify';
import { MapContainer, TileLayer, Marker, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import * as global from '../utils/globals';

const defaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

L.Marker.prototype.options.icon = defaultIcon;

function changeFavicon(url) {
    let link = document.querySelector("link[rel='icon']");
    if (!link) {
        link = document.createElement("link");
        link.rel = "icon";
        document.head.appendChild(link);
    }
    link.href = url;
}

function ChangeView({ center }) {
    const map = useMap();
    map.setView(center);
    return null;
}

const DigitalMenu = ({ company }) => {
    const [activeCategory, setActiveCategory] = useState('All');
    const [activeSubCategory, setActiveSubCategory] = useState('');
    const [themes, setThemes] = useState([]);
    const [dmitems, setDmItems] = useState([]);
    const [subCate, setSubCate] = useState([]);
    const [curr1, setCurr1] = useState(null);
    const [curr2, setCurr2] = useState(null);
    const [allSubCate, setAllSubCate] = useState([]);
    const [allCate, setAllCate] = useState([]);
    const [newDmItems, setNewDmItems] = useState([]);
    const [RateSecondToFirst, setRateSecondToFirst] = useState(0);

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        comment: "",
    });

    const [lat, setLat] = useState(33.8938);
    const [lng, setLng] = useState(35.5018);

    const position = [parseFloat(lat), parseFloat(lng)];

    useEffect(() => {
        getDMThemes(company).then((x) => setThemes(x));
        getDMItems(company).then((x) => setDmItems(x));
        getDMCategories(company).then((x) => setAllCate(x));
        getDMSubAndMainCategories(company).then((x) => setAllSubCate(x));
        getCurrencies(company).then((x) => {
            for (let c of x) {
                if (c.cur_priority === 1)
                    setCurr1(c);
                else setCurr2(c);
            }
        });
    }, []);

    useEffect(() => {
        if (curr1 && curr2)
            findRate(curr2.cur_id, curr1.cur_id).then(
                (res) => setRateSecondToFirst(res[0]?.rate)
            );
    }, [curr1, curr2]);

    useEffect(() => {
        if (dmitems.length > 0) {
            const newItems = [];
            for (let item of dmitems) {
                for (let sub of allSubCate) {
                    if (item.dmit_dmsbc_id === sub.dmsbc_id) {
                        var code = curr1?.cur_code || '';
                        var newPrice = null;
                        if (item.dmit_curr !== curr1?.cur_id) {
                            newPrice = Math.round(((item.dmit_price * RateSecondToFirst) + Number.EPSILON) * 100) / 100;
                        }
                        const obj = {
                            id: item.dmit_id,
                            title: item.dmit_name,
                            price: newPrice || item.dmit_price,
                            desc: item.dmit_description,
                            img: item.dmit_image,
                            category: sub.dmsbc_name,
                            curr: code,
                        }
                        newItems.push(obj);
                    }
                }
            }
            setNewDmItems(newItems);
        }
    }, [dmitems, allSubCate, curr1, RateSecondToFirst]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    }

    const handleAddFeedback = (e) => {
        e.preventDefault();
        if (formData.comment === '') {
            toastMessage("Feedback cannot be empty", "error");
            return;
        }

        const obj = {};
        obj.dmfb_cmp_id = company;
        obj.dmfb_name = formData.name;
        obj.dmfb_phone = formData.phone;
        obj.dmfb_email = formData.email;
        obj.dmfb_comment = formData.comment;

        const data = [];
        data.push(obj);
        addDMFeedback(data);
    }

    const addDMFeedback = (params) => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const raw = JSON.stringify({ params });
        const requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };
        fetch(`${global.baseUrl}dmfeedback/add_dmfeedback`, requestOptions)
            .then((response) => response.json())
            .then((response) => {
                if (response.success) {
                    toastMessage("Thank you for your feedback!", "success");
                    setFormData({
                        name: "",
                        phone: "",
                        email: "",
                        comment: "",
                    });
                }
                if (!response.error) {

                } else {
                    toastMessage(response.error[0].originalError.info.message, "error");
                }
            });
    };

    useEffect(() => {
        if (allCate.length > 0 && allSubCate.length > 0) {

            const result = allCate.map(cat => ({
                ...cat,

                subcategories: allSubCate
                    .filter(s => s.dmsbc_dmcat_id === cat.dmcat_id)
                    .map(s => ({
                        name: s.dmsbc_name,
                        image: s.dmsbc_image,
                        color: s.dmsbc_color,
                        fontColor: s.dmsbc_fontcolor,
                        fontSize: s.dmsbc_fontsize,
                        fontStyle: s.dmsbc_fontstyle,
                        priority: s.dmsbc_priority
                    }))
                    .sort((a, b) => a.priority - b.priority)
            }));

            setSubCate(result);
        }
    }, [allCate, allSubCate]);

    const { mainMapping, showCate } = useMemo(() => {
        const mainMapping = {};
        const showCate = [];

        subCate.forEach(cat => {
            showCate.push({
                name: cat.dmcat_name,
                fontSize: cat.dmcat_fontsize || '0.85rem',
                fontStyle: cat.dmcat_fontstyle,
                color: cat.dmcat_color,
                fontColor: cat.dmcat_fontcolor,
                priority: cat.dmcat_priority
            });

            const names = cat.subcategories.map(s => s.name);

            mainMapping[cat.dmcat_name] = names;

            mainMapping["All"] = [
                ...(mainMapping["All"] || []),
                ...names
            ];
        });

        return { mainMapping, showCate };
    }, [subCate]);

    const theme = {
        bg: themes[0]?.dmth_fullbgcolor,
        card: themes[0]?.dmth_bgphoto,
        itemColor: themes[0]?.dmth_itemsnamecolor,
        noteColor: themes[0]?.dmth_itemsnotecolor,
        priceColor: themes[0]?.dmth_itemspricecolor,
        accent: themes[0]?.dmth_bgphoto1,
        border: themes[0]?.dmth_bgphoto2,
        itemNameSize: themes[0]?.dmth_itemsnamesize,
        itemNoteSize: themes[0]?.dmth_itemsnotesize,
        itemPriceSize: themes[0]?.dmth_itemspricesize,
        noteStyle: themes[0]?.dmth_itemsnotestyle,
        nameStyle: themes[0]?.dmth_itemsnamestyle,
        priceStyle: themes[0]?.dmth_itemspricestyle,
        aboutMsg: themes[0]?.dmth_aboutmessage,
        aboutTitle: themes[0]?.dmth_abouttitle,
        address: themes[0]?.dmth_address,
        footerNote: themes[0]?.dmth_footernote,
        mapCoord: themes[0]?.dmth_mapcoord,
        web: themes[0]?.dmth_website,
        email: themes[0]?.dmth_email,
        phone1: themes[0]?.dmth_phone1,
        phone: themes[0]?.dmth_phone,
        name: themes[0]?.dmth_name,
        social1: themes[0]?.dmth_socialmedia1,
        social2: themes[0]?.dmth_socialmedia2,
        social3: themes[0]?.dmth_socialmedia3,
        social4: themes[0]?.dmth_socialmedia4,
        bgPhoto: themes[0]?.dmth_bgphoto,
        bgPhoto1: themes[0]?.dmth_bgphoto1,
        bgPhoto2: themes[0]?.dmth_bgphoto2,
        bgPhoto3: themes[0]?.dmth_bgphoto3,
        bgPhoto4: themes[0]?.dmth_bgphoto4,
        categoryTitle: themes[0]?.dmth_categorytitle,
        subCategoryTitle: themes[0]?.dmth_subcategorytitle,
        specialtyTitle: themes[0]?.dmth_specialtytitle,
        specialtyMsg: themes[0]?.dmth_specialtymessage,
        feedbackTitle: themes[0]?.dmth_feedbacktitle,
        image: themes[0]?.dmth_image,
        image1: themes[0]?.dmth_image1,
        socialMedia1Image: themes[0]?.dmth_socialmedia1image,
        socialMedia2Image: themes[0]?.dmth_socialmedia2image,
        socialMedia3Image: themes[0]?.dmth_socialmedia3image,
        socialMedia4Image: themes[0]?.dmth_socialmedia4image,
    };

    useEffect(() => {
        document.title = theme.name || 'Digital Menu';
        changeFavicon(theme.image);

        if (theme.mapCoord) {
            const [lat, lng] = theme.mapCoord.split(",").map(Number);
            setLat(lat);
            setLng(lng);
        }
    }, [theme]);

    const scrollToId = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    return (
        <div style={{ backgroundColor: theme.bg, color: theme.accent, minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <ToastContainer />
            <div style={{ display: 'flex', flex: 1 }}>
                <main style={{ flex: 1, padding: '2rem' > 0 ? '380px' : '2rem' }}>

                    <header style={{ textAlign: 'center', marginBottom: '3rem' }}>
                        <h1 style={{ fontSize: '3.5rem', margin: 0, fontWeight: '900', color: theme.accent }}>{theme.name}</h1>
                    </header>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
                            {[{ name: "All", color: theme.accent }, ...showCate].map(c => (
                                <button
                                    key={c.name}
                                    onClick={() => {
                                        setActiveCategory(c.name);
                                        setActiveSubCategory('');
                                    }}
                                    style={{
                                        padding: '8px 18px',
                                        borderRadius: '20px',
                                        border: `1px solid ${c.color}`,
                                        background: activeCategory === c.name ? c.color : 'transparent',
                                        color: activeCategory === c.name ? c.fontColor : c.color,
                                        cursor: 'pointer',
                                        textTransform: 'capitalize',
                                        fontSize: `${c.fontSize || 0.85}rem`,
                                        fontStyle: c.fontStyle
                                    }}
                                >{c.name}</button>
                            ))}
                            <button
                                onClick={() => {
                                    scrollToId('about-section')
                                }}
                                style={{
                                    padding: '8px 18px',
                                    borderRadius: '20px',
                                    border: `1px solid ${theme.accent}`,
                                    background: theme.bg,
                                    color: theme.accent,
                                    cursor: 'pointer',
                                    textTransform: 'capitalize',
                                    fontSize: `0.85rem`
                                }}
                            >About</button>
                            <button
                                onClick={() => {
                                    scrollToId('feedback-section')
                                }}
                                style={{
                                    padding: '8px 18px',
                                    borderRadius: '20px',
                                    border: `1px solid ${theme.accent}`,
                                    background: theme.bg,
                                    color: theme.accent,
                                    cursor: 'pointer',
                                    textTransform: 'capitalize',
                                    fontSize: `0.85rem`
                                }}
                            >Feedback</button>
                        </div>

                        {activeCategory !== 'All' && (
                            <div style={{
                                width: '150px',
                                height: '1px',
                                background: theme.accent,
                                opacity: 0.3,
                                margin: '5px 0'
                            }}></div>
                        )}

                        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', flexWrap: 'wrap' }}>
                            {activeCategory !== 'All' && subCate.find(c => c.dmcat_name === activeCategory)?.subcategories.map(sub => (
                                <button
                                    key={sub.name}
                                    onClick={() => setActiveSubCategory(sub.name)}
                                    style={{
                                        padding: '6px 14px',
                                        borderRadius: '15px',
                                        border: `1px solid ${theme.accent}66`,
                                        background: activeSubCategory === sub.name ? sub.color : 'transparent',
                                        color: activeSubCategory === sub.name ? sub.fontColor : sub.color,
                                        cursor: 'pointer',
                                        textTransform: 'capitalize',
                                        fontSize: `${sub.fontSize || 0.85}rem`,
                                        fontStyle: sub.fontStyle
                                    }}
                                >
                                    {sub.name}
                                </button>
                            ))}
                        </div>

                    </div>

                    {(() => {

                        let categoriesToShow = mainMapping[activeCategory] || [];

                        if (activeSubCategory) {

                            const selected = categoriesToShow.find(
                                cat => cat.toLowerCase() === activeSubCategory.toLowerCase()
                            );
                            if (selected) categoriesToShow = [selected];
                        }

                        return categoriesToShow.map(cat => {
                            const items = newDmItems.filter(i => i.category === cat);
                            if (items.length === 0) return null;

                            return (
                                <section key={cat} style={{ marginBottom: '4rem' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '2rem' }}>
                                        <h2 style={{ fontSize: '2rem', margin: 0, color: theme.accent }}>{cat}</h2>
                                        <div style={{ flex: 1, height: '1px', background: theme.accent, opacity: 0.3 }}></div>
                                    </div>
                                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '2.5rem' }}>
                                        {items.map(item => (
                                            <article key={item.id} style={{
                                                background: theme.card, borderRadius: '20px', overflow: 'hidden',
                                                border: `1px solid ${theme.border}`, boxShadow: '0 4px 6px rgba(0,0,0,0.02)'
                                            }}>
                                                <div style={{ padding: '1.5rem' }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                                        <h4 style={{ margin: 0, fontSize: `${theme.itemNameSize || 1.25}rem`, color: theme.itemColor, fontStyle: theme.nameStyle }}>
                                                            {item.title}</h4>
                                                        <span style={{
                                                            fontWeight: 'bold', color: theme.priceColor, fontSize: `${theme.itemPriceSize || 1.25}rem`,
                                                            fontStyle: theme.priceStyle
                                                        }}>
                                                            {item.curr} {item.price?.toFixed(2) || 0}</span>
                                                    </div>
                                                    {item.img &&
                                                        (<img src={item.img || null} alt={item.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />)}
                                                    <p style={{
                                                        fontSize: `${theme.itemNoteSize || 0.85}rem`, opacity: 0.7,
                                                        margin: '10px 0', height: '40px', fontStyle: theme.noteStyle, color: theme.noteColor
                                                    }}>
                                                        {item.desc || "No description available."}
                                                    </p>
                                                </div>
                                            </article>
                                        ))}
                                    </div>
                                </section>
                            );
                        });
                    })()}

                    {theme.aboutMsg && theme.aboutTitle &&
                        <section style={{ marginBottom: '4rem' }} id="about-section">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '2rem' }}>
                                <h2 style={{ fontSize: '2rem', margin: 0, color: theme.accent }}>{theme.aboutTitle}</h2>
                                <div style={{ flex: 1, height: '1px', background: theme.accent, opacity: 0.3 }}></div>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '2.5rem' }}>
                                <article style={{
                                    background: theme.card, borderRadius: '20px', overflow: 'hidden',
                                    border: `1px solid ${theme.border}`, boxShadow: '0 4px 6px rgba(0,0,0,0.02)'
                                }}>
                                    <div style={{ padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                                        <p style={{ letterSpacing: '2px' }}>{theme.aboutMsg}</p>
                                    </div>
                                </article>
                            </div>
                        </section>}

                    {theme.feedbackTitle &&
                        <section style={{ marginBottom: '4rem' }} id="feedback-section">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginBottom: '2rem' }}>
                                <h2 style={{ fontSize: '2rem', margin: 0, color: theme.accent }}>{theme.feedbackTitle}</h2>
                                <div style={{ flex: 1, height: '1px', background: theme.accent, opacity: 0.3 }}></div>
                            </div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '2.5rem' }}>
                                <article style={{
                                    background: theme.card, borderRadius: '20px', overflow: 'hidden',
                                    border: `1px solid ${theme.border}`, boxShadow: '0 4px 6px rgba(0,0,0,0.02)'
                                }}>
                                    <div style={{ padding: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexDirection: 'column' }}>
                                        <label style={{ marginBottom: '10px', fontWeight: 'bold' }}>We value your feedback! Please fill out the form below:</label>
                                        <input type="text" placeholder="Your name..." value={formData.name} onChange={handleChange} name="name" style={{
                                            width: '100%', padding: '8px', marginBottom: '10px',
                                            borderRadius: '10px', border: `1px solid ${theme.border}`
                                        }} />
                                        <input type="text" placeholder="Your phone..." value={formData.phone} onChange={handleChange} name="phone"
                                            onKeyPress={(event) => {
                                                if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                }
                                            }}
                                            style={{
                                                width: '100%', padding: '8px', marginBottom: '10px',
                                                borderRadius: '10px', border: `1px solid ${theme.border}`,
                                                type: 'tel', pattern: '[0-9]*', inputMode: 'numeric'
                                            }} />
                                        <input type="email" placeholder="Your email..." value={formData.email} onChange={handleChange} name="email" style={{
                                            width: '100%', padding: '8px', marginBottom: '10px',
                                            borderRadius: '10px', border: `1px solid ${theme.border}`
                                        }} />
                                        <textarea placeholder="Your feedback..." value={formData.comment} onChange={handleChange} name="comment" style={{
                                            width: '100%', height: '100px', padding: '8px',
                                            borderRadius: '10px', border: `1px solid ${theme.border}`, resize: 'none'
                                        }}></textarea>
                                        <button style={{
                                            marginTop: '10px', padding: '8px 16px', borderRadius: '20px',
                                            background: theme.accent, color: theme.card, border: 'none', cursor: 'pointer'
                                        }} onClick={handleAddFeedback}>Submit</button>
                                    </div>
                                </article>
                            </div>
                        </section>}

                    <footer style={{ marginTop: '6rem', padding: '4rem 0 2rem 0', borderTop: `1px solid ${theme.border}`, textAlign: 'center', position: 'relative' }}>
                        {theme.mapCoord &&
                            <div style={{ display: "flex", justifyContent: "center" }}>
                                <MapContainer
                                    center={position}
                                    zoom={13}
                                    style={{ height: "400px", width: "90%", marginTop: "10px" }}
                                >
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <Marker
                                        position={position}
                                        eventHandlers={{
                                            click: () => {
                                                const lat = position[0];
                                                const lng = position[1];

                                                const url = `https://www.google.com/maps?q=${lat},${lng}`;
                                                window.open(url, "_blank");
                                            },
                                        }}
                                    />
                                    <ChangeView center={position} />
                                </MapContainer>
                            </div>
                        }
                        <h3 style={{ letterSpacing: '3px', fontSize: '1.1rem' }}>{theme.name}</h3>
                        <p style={{ fontSize: '1rem', maxWidth: '400px', margin: '15px auto' }}>{theme.footerNote}</p>
                        <p style={{ fontSize: '0.85rem', opacity: 0.6, maxWidth: '400px', margin: '15px auto' }}>{theme.address}</p>

                        <div style={{ display: 'flex', justifyContent: 'center', gap: 15, marginTop: 10 }}>
                            {theme.social1 && (<a href={theme.social1} target="_blank" rel="noopener noreferrer"><img src={theme.socialMedia1Image} alt=''
                                style={{ objectFit: 'cover', width: '24px', height: '24px' }} /></a>)}
                            {theme.social2 && (<a href={theme.social2} target="_blank" rel="noopener noreferrer"><img src={theme.socialMedia2Image} alt=''
                                style={{ objectFit: 'cover', width: '24px', height: '24px' }} /></a>)}
                            {theme.social3 && (<a href={theme.social3} target="_blank" rel="noopener noreferrer"><img src={theme.socialMedia3Image} alt=''
                                style={{ objectFit: 'cover', width: '24px', height: '24px' }} /></a>)}
                            {theme.social4 && (<a href={theme.social4} target="_blank" rel="noopener noreferrer"><img src={theme.socialMedia4Image} alt=''
                                style={{ objectFit: 'cover', width: '24px', height: '24px' }} /></a>)}
                        </div>

                        <small>
                            {" "}
                            &copy; {new Date().getFullYear()} DataHarbor - All Rights
                            Reserved.
                        </small>

                        <div style={{ marginTop: '40px', fontSize: '0.75rem', opacity: 0.8 }}>
                            Powered By <a href="https://dataharborlb.com" target="_blank" rel="noreferrer"
                                style={{ color: theme.accent, textDecoration: 'none', fontWeight: 'bold' }}>Dataharbor</a>
                        </div>
                    </footer>
                </main>
            </div>
        </div >
    )
}

export default DigitalMenu